// 营养科普 - 详情
import { useState, useEffect } from "react"
import { Modal, Spin } from "antd"
import TitleComponent from "@/components/sc/TitleComponent"
import PageFooter from "@/components/sc/PageFooter"
import api from "@/net/api"
import moment from "moment"

import "./info.less"

export default function Info(props) {
	const [info, setInfo] = useState(null)
	useEffect(() => {
		getInfo()
	}, [])
	async function getInfo() {
		try {
			let d = await api.popularization_details({ id: props.id })
			d.createTime_ = moment(d.createTime).format("YYYY.MM.DD HH:mm")
			setInfo(d)
		} catch(e) {
			console.log(e)
		}
	}

	// ----------------------------------------------------------------------
	const [modal, setModal] = useState({
		visible: false,
		src: "",
	})
	function onContentClick(e) {
		if (e.target.tagName != "IMG") {
			return
		}
		setModal({
			visible: true,
			src: e.target.src,
		})
	}

	return (
	<>
		<div className="pages_main_nutrition-science_info">
			<TitleComponent title="" />

			<div className="body">
				{info
				? <div className="body-main">
					<div className="main-title">{ info.title }</div>
					<div className="main-time">发布时间: { info.createTime_ }</div>
					<div className="main-content" dangerouslySetInnerHTML={{ __html: info.content }} onClick={onContentClick}></div>
				</div>
				: <Spin className="loading" />
				}
				<PageFooter style={{ color: "#747474", marginTop: "26px" }} />
			</div>
		</div>

		<Modal open={modal.visible} centered footer={null} closable={false}
				onCancel={() => setModal({ visible: false, src: "" })}
				width={"1280px"} bodyStyle={{ padding: "0" }}>
			<img src={modal.src} alt="img" style={{ width: "1280px" }} />
		</Modal>
	</>
	)
}
